export const getPublishPreflightErrors = ({ selectedTemplateId, brandName, layoutBuilder, normalizeWidgetComponent, supportedComponents }) => {
  const errors = [];
  if (!selectedTemplateId) errors.push('Select a template.');
  if (!String(brandName || '').trim()) errors.push('Brand name is required.');

  const homeWidgets = layoutBuilder?.slots?.home || [];
  if (!Array.isArray(homeWidgets) || homeWidgets.length === 0) {
    errors.push('Add at least one widget to the home slot.');
  }

  Object.entries(layoutBuilder?.slots || {}).forEach(([slot, widgets]) => {
    (Array.isArray(widgets) ? widgets : []).forEach((widget, index) => {
      const normalized = normalizeWidgetComponent(widget?.component);
      if (!supportedComponents.has(normalized)) {
        errors.push(`Unsupported widget "${widget?.component || 'unknown'}" in ${slot} slot (#${index + 1}).`);
      }
    });
  });

  return errors;
};

export const getPublishPreflightMessage = (errors) => {
  if (errors.length === 1) return `Cannot publish yet: ${errors[0]}`;
  return `Cannot publish yet. Fix ${errors.length} issues before publishing.`;
};

export const publishBuilderDocument = ({ axiosClient, endpoint, headers, selectedTemplateId, overrides }) => (
  axiosClient.post(endpoint, { templateId: selectedTemplateId, overrides }, headers)
);
